import styled from 'styled-components';

export const Background = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.6);
    z-index: 1000;
    display: none;

    &.opened {
        display: block;
    }
`;

export const Window = styled.div`
    display: none;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 700px;
    height: 400px;
    max-height: 400px;
    background-color: #111;
    border: 1px solid #333;
    z-index: 1001;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.opened {
        display: flex;
    }
`;

export const Content = styled.div`
    flex: 1;
    width: 100%;
    max-height: calc(100% - 71px);
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    background-color: #333;
    height: 30px;
    min-height: 30px;
    width: 100%;
`;

export const HeaderTitle = styled.div`
    padding-left: 5px;
    font-size: 14px;
    text-transform: uppercase;
    color: #fff;
`;

export const ButtonBar = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #333;
    width: 100%;
`;

export const ButtonSide = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

export const Button = styled.label`
    border: 1px solid ${props => props.color ?? '#fff'};
    color: ${props => props.color ?? '#fff'};
    padding: 0 15px;
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all .3s ease 0s;
    margin-left: 10px;

    :first-child{
        margin-left: 0;
    }

    :hover {
        color: #000;
        background-color: ${props => props.color ?? '#fff'};
    }
`;

export const ShowButton = styled.a`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    top: 25px;
    left: 80px;
    z-index: 4;
    height: 20px;
    width: 20px;
    background-color: #000;
    border-radius: 10px;
    border: 1px solid #ccc;
    color: #ccc;
    transition: all .4s ease 0s;
    text-decoration: none;
    cursor: pointer;
    
    :before {
        content: '\\F00E4';
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-family: 'Material Design Icons';
        font-size: 10px;
    }
    
    :hover {
        color: #000;
        background-color: #ccc;
    }
`;

export const ReportText = styled.div`
    flex: 2;
    border-right: 1px solid #333;
    color: #fff;
    padding: 20px;
`;

export const ReportForm = styled.div`
    flex: 3;
    color: #fff;
    padding: 20px;
`;

export const Heading = styled.div`
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
`;

export const Text = styled.div`
    font-size: 14px;
    line-height: 20px;
    margin-top: 30px;
`;

export const Label = styled.div`
    font-size: 11px;
    color: #999;
    margin-top: 10px;
    text-transform: uppercase;

    &:first-child {
        margin-top: 0;
    }
`;

export const FileLabel = styled.div`
    font-size: 11px;
    margin: 0 0 0 10px;
    text-transform: uppercase;
`;

export const TextArea = styled.textarea.attrs(p => ({
    className: "scrollbar"
}))`
    border: 1px solid #666;
    color: #fff;
    width: 100%;
    height: 200px;
    background-color: transparent;
    padding: 5px;
    resize: none;

    &:first-child {
        margin-top: 0;
    }
`;

export const ImagesUpload = styled.input.attrs(p => ({
    type: "file",
    multiple: true,
    accept: "image/png,image/jpeg"
    
}))`
    display: none;
    border: 1px solid #666;
    color: #fff;
    width: 100%;
    background-color: transparent;
    padding: 5px;
`;

export const ReportSuccess = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #090;
`;

export const ReportError = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #f44;
`;
